// extracted by mini-css-extract-plugin
export var arrow_icon = "DropDownRefact-module--arrow_icon--bb086";
export var category_container = "DropDownRefact-module--category_container--d20c1";
export var category_dropdown = "DropDownRefact-module--category_dropdown--f13f9";
export var category_item = "DropDownRefact-module--category_item--01dee";
export var category_link = "DropDownRefact-module--category_link--bdbd0";
export var category_list = "DropDownRefact-module--category_list--49e29";
export var category_parent = "DropDownRefact-module--category_parent--a0d84";
export var destacados_container = "DropDownRefact-module--destacados_container--4ea8c";
export var dropdown_title = "DropDownRefact-module--dropdown_title--4cb2d";
export var main_container = "DropDownRefact-module--main_container--a5269";
export var main_dropdown = "DropDownRefact-module--main_dropdown--17cc9";
export var open = "DropDownRefact-module--open--a422e";
export var subcategory_item = "DropDownRefact-module--subcategory_item--ae894";